import { LssProp, Tag, Text } from '@lucidhq/lucidium';

const tagLss: LssProp = {
  borderRadius: 'sm',
  gap: '8px',
  padding: '4px 12px',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
};

const textLss: LssProp = {
  color: 'primary500',
  fontSize: '12px',
};

export interface StatusProps<T extends string> {
  status: T;
  statusMap: Record<T, string>;
  colorMap: Record<T, LssProp>;
  width?: string;
}

export const Status = <T extends string>({
  status,
  statusMap,
  colorMap,
  width = '90px',
}: StatusProps<T>) => (
  <Tag lss={{ width, ...tagLss, ...colorMap[status] }} hasOutline>
    <Text as="strong" lss={textLss}>
      {statusMap[status]}
    </Text>
  </Tag>
);
